"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var component_icon_font_1 = __importDefault(require("@rotaryintl/component-icon-font"));
var hook_use_on_click_outside_1 = __importDefault(require("@rotaryintl/hook-use-on-click-outside"));
var classnames_1 = __importDefault(require("classnames"));
var link_component_1 = require("../link/link.component");
var SearchDropdown = function (_a) {
  var searchOptionLinks = _a.searchOptionLinks;
  var _b = (0, react_1.useState)(false),
    isOpen = _b[0],
    setIsOpen = _b[1];
  var _c = (0, react_1.useState)(false),
    isMouseOver = _c[0],
    setIsMouseOver = _c[1];
  var dropdownRef = (0, react_1.useRef)(null);
  var triggerButtonRef = (0, react_1.useRef)(null);
  (0, hook_use_on_click_outside_1.default)(dropdownRef, function () {
    return setIsOpen(false);
  });
  (0, react_1.useEffect)(function () {
    if (!isOpen) {
      setIsMouseOver(false);
    }
  }, [isOpen]);
  return (0, jsx_runtime_1.jsxs)("div", __assign({
    className: (0, classnames_1.default)('rwc-search-dropdown', {
      'rwc-search-dropdown--open': isOpen,
      'rwc-search-dropdown--hover': isMouseOver
    }),
    ref: dropdownRef
  }, {
    children: [(0, jsx_runtime_1.jsx)("button", __assign({
      type: "button",
      "aria-haspopup": "menu",
      "aria-expanded": isOpen,
      id: "search-options-button",
      "aria-controls": "search-options-menu",
      ref: triggerButtonRef,
      onMouseEnter: function () {
        if (!isOpen) setIsMouseOver(true);
      },
      onMouseLeave: function () {
        return setIsMouseOver(false);
      },
      className: "rwc-search-dropdown__button",
      onClick: function () {
        return setIsOpen(!isOpen);
      }
    }, {
      children: (0, jsx_runtime_1.jsx)(component_icon_font_1.default, {
        type: "fas-search",
        color: "#323C44",
        size: "16"
      })
    })), (0, jsx_runtime_1.jsx)("ul", __assign({
      role: "menu",
      "aria-label": "search options menu",
      id: "search-options-menu",
      className: (0, classnames_1.default)('rwc-search-dropdown__panel', {
        'rwc-search-dropdown__panel--open': isOpen
      })
    }, {
      children: searchOptionLinks === null || searchOptionLinks === void 0 ? void 0 : searchOptionLinks.map(function (link) {
        return (0, jsx_runtime_1.jsx)("li", {
          children: (0, jsx_runtime_1.jsx)(link_component_1.Link, __assign({
            className: "rwc-search-dropdown__panel-item",
            role: "menuitem"
          }, link))
        }, "rwc-search-dropdown__panel-item-".concat(link.linkText, "-").concat(link.linkUrl));
      })
    }))]
  }));
};
exports.default = SearchDropdown;